module.exports = __webpack_public_path__ + "img/icon-lock.84b44688.svg";